/**
 * Analytics Components Index
 *
 * Google Tag Manager (GTM) is used as the primary analytics container.
 * GA4 is configured as a tag within GTM for flexibility.
 * This allows marketing to manage tags without code changes.
 */

export {
  GoogleTagManager,
  GoogleTagManagerNoScript,
  pushToDataLayer,
  trackGTMEvent,
  trackGTMPageView,
  trackGTMPurchase,
  trackGTMPaywallView,
  trackGTMContentAccess,
  trackGTMSearch,
  trackGTMSearchClick,
} from "./GoogleTagManager";

export { MicrosoftClarity } from "./MicrosoftClarity";
